import { Col } from "reactstrap";
import { Btn, Image } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Service/DynamicImage";
import { CommonBohoModalTitle } from "../Common/CommonBohoModalTitle";
import { useState } from "react";
import { ProfileModal } from "./ProfileModal";
import { ClickOut } from "../../../../../Constant";

export const ModalOne = () => {
  const [modalOne, setModalOne] = useState(false);
  const modalOneTogggle = () => setModalOne(!modalOne);
  return (
    <Col xl="4" md="6" className="custom-alert text-center">
      <div className="card-wrapper border rounded-3 h-100">
        <div className="Boho-demo-img">
          <CommonBohoModalTitle heading="Modal 1 -" subHeading="Profile Modal" text="Example of Boho dashboard profile card." />
          <div className="overflow-hidden">
            <Image className="image-fluid" src={dynamicImage("alert/social.png")} alt="social" />
            <Btn color="primary" className="mx-auto mt-3" type="button" onClick={modalOneTogggle}>{ClickOut}</Btn>
          </div>
          <ProfileModal modalOne={modalOne} modalOneTogggle={modalOneTogggle}/>
        </div>
      </div>
    </Col>
  );
};
